function normalizeUrl(url) {
  return String(url || "").trim();
}

function tryParseUrl(url) {
  const value = normalizeUrl(url);
  if (!value) return null;
  try {
    return new URL(value);
  } catch {
    return null;
  }
}

function replaceGoogleAvatarSize(url, size) {
  const parsed = tryParseUrl(url);
  if (!parsed) return normalizeUrl(url);
  const host = parsed.hostname.toLowerCase();
  if (!host.includes("googleusercontent.com")) {
    return parsed.toString();
  }

  // Handles common Google avatar suffixes like `=s96-c` or `=s96`.
  const suffixPattern = /=s\d+(-c)?$/;
  if (suffixPattern.test(parsed.pathname)) {
    parsed.pathname = parsed.pathname.replace(suffixPattern, `=s${size}-c`);
    return parsed.toString();
  }

  return `${parsed.toString()}=s${size}-c`;
}

function buildDefaultSrcSet(src) {
  if (!src) return "";
  return `${src} 1x, ${src} 2x`;
}

export function buildAvatarImageAttrs(url, { size = 40 } = {}) {
  const normalized = normalizeUrl(url);
  if (!normalized) {
    return { src: "", srcSet: "", sizes: "" };
  }

  const src = replaceGoogleAvatarSize(normalized, size);
  const highDprSrc = replaceGoogleAvatarSize(normalized, size * 2);
  const srcSet =
    highDprSrc && highDprSrc !== src
      ? `${src} 1x, ${highDprSrc} 2x`
      : buildDefaultSrcSet(src);

  return {
    src,
    srcSet,
    sizes: `${size}px`,
  };
}

export function buildPosterImageAttrs(url, { sizes = "100vw" } = {}) {
  const src = normalizeUrl(url);
  if (!src) {
    return { src: "", srcSet: "", sizes: "" };
  }

  return {
    src,
    srcSet: buildDefaultSrcSet(src),
    sizes,
  };
}

